'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { useProps, packSX, transformExtendedQuery } from '@s7/styles';
import { arrayOf } from '@s7/utils';
import { IDENT } from './MediaQuery.contract.js';
import { Box } from '../Box/Box.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const transformQueryToMedia = (theme, _query, units)=>{
    const computedQuery = transformExtendedQuery(_query, units, false)(theme);
    if (computedQuery) {
        return computedQuery;
    }
    if (_query in theme.breakpoints) {
        return theme.fn.up(_query, units, true);
    }
    return _query;
};
const MediaQuery = (props)=>{
    const _useProps = useProps(IDENT, props), [{ query, className, sx, children }] = _useProps, others = _object_without_properties_loose(_useProps[0], [
        "query",
        "className",
        "sx",
        "children"
    ]);
    const [_query, styles = {
        display: 'none'
    }] = arrayOf(query);
    return /*#__PURE__*/ jsx(Box, _extends({}, others, {
        sx: [
            (theme)=>({
                    [transformQueryToMedia(theme, _query)]: styles
                }),
            ...packSX(sx)
        ],
        children: children
    }));
};
var MediaQuery$1 = MediaQuery;
MediaQuery.displayName = IDENT;

export { MediaQuery, MediaQuery$1 as default };
//# sourceMappingURL=MediaQuery.js.map
